/**
 * @module
 *
 * @import {Controller} from '@acng/frontend-stargazer'
 */
import {CONNECT} from '@acng/frontend-stargazer';
import {INPUT} from '@acng/frontend-bounty/dom/event.js';
import {query} from '@acng/frontend-bounty/dom/query.js';
import {guard} from '@acng/frontend-rubicon';
import {OneTimeCodeFormController} from '../../layout/controller/one-time-code-form.js';

import {post} from '../../core/service/backend.js';
import {AUTH_USER_DATA} from '../model/user-data.js';
import {getLocalOverlay} from '../../core/service/overlay.js';
import {performLogin} from './login.js';

/**
 * @example
 *
 * ```html
 * <!--@ ${auth.login.twoFactor} -->
 * ```
 *
 * @implements {Controller}
 *
 * @todo
 *
 *   - Dictionary(DOM): "action", "focus"
 *   - Dictionary(Nova): "getInputCode"
 *   - Remove overlay close hack
 */
class TwoFactorLogin extends OneTimeCodeFormController {
  constructor() {
    super(TwoFactorLogin.#submit);
  }

  /**
   * @param {Element} form
   */
  [CONNECT](form) {
    super[CONNECT](form);
    query(form, INPUT)?.focus();
  }

  /**
   * @param {HTMLFormElement} form
   * @param {string} code
   */
  static async #submit(form, code) {
    const url = 'user/confirm-device';
    const userData = await post(url, {code}, form);
    ASSERT: guard(userData, AUTH_USER_DATA, `decoded ${url} response body`);
    performLogin(userData);
    getLocalOverlay(form)?.close();
  }
}

export {TwoFactorLogin};
